import type { SuluAutomationStep } from '../models/suluAutomation.types';

/** Accepts the automation list from GET /customer/getsuluautomation. */
export const normalizeSuluAutomationPayload = (payload: unknown): SuluAutomationStep[] => {
  if (!Array.isArray(payload)) {
    return [];
  }
  return payload.flatMap((item) => {
    if (!item || typeof item !== 'object') {
      return [];
    }
    const row = item as Record<string, unknown>;
    const statusName = row.statusName ?? row.StatusName;
    const status = row.status ?? row.Status;
    if (typeof statusName !== 'string' || !statusName.trim()) {
      return [];
    }
    return [
      {
        statusName: statusName.trim(),
        status: typeof status === 'string' ? status.trim() : '',
      },
    ];
  });
};
